module.exports = __webpack_public_path__ + "components/flag/static/square/tv-623070a2a37dc74bb3bd4dd0e6a5ab8a.svg";